<template>
    <div class="request-dossier-modal">
        <el-dialog
            v-model="modelValueState"
            :title="$trans('web_search.add_to_board_modal.board_request_title')"
            :show-close="false"
            @closed="resetForm"
        >
            <template #header>
                <div class="modal-header">
                    <span class="title-col">
                        {{ $trans('web_search.add_to_board_modal.board_request_title') }}
                    </span>
                    <CloseModalButton @click="modelValueState = false" />
                </div>
            </template>

            <template v-if="successMessage">
                <el-row>
                    <div class="success-wrapper">{{ successMessage }}</div>
                </el-row>
            </template>

            <template v-else>
                <el-row class="your-selection-content">
                    <el-col style="border-bottom: 1px solid;">
                        <div class="tag-header">
                            <span>{{ $trans('web_search.add_to_board_modal.search_terms') }}</span>
                        </div>
                        <div class="match-rate-header">
                            <span>{{ $trans('web_search.add_to_board_modal.match_rate') }}</span>
                        </div>
                        <div class="your-selection-row">
                            <div>
                                <img :src="profile.avatar_url" alt="Avatar" />
                            </div>
                            <div>
                                <template v-for="(filter, index) in profile.activeSkills" :key="index">
                                    <Tag size="small" :text="filter.name" />
                                </template>
                                <template v-for="(filter, index) in profile.activeFilters" :key="index">
                                    <Tag size="small" :text="filter" />
                                </template>
                            </div>
                            <div class="match-rate">
                                <div>
                                    <span class="color-black">
                                        {{ profile.percentage_score_avg }}
                                    </span>
                                    <span class="color-grey"> / 100</span>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="24">
                        <el-form
                            ref="formRef"
                            label-position="top"
                            label-width="100px"
                            :model="formData"
                            :rules="rules"
                            require-asterisk-position="right"
                        >
                            <el-form-item class="flex-wrap-on-mobile">
                                <el-col :span="6" style="padding-left: 0">
                                    <el-form-item
                                        :label="$trans('web_search.checkout_fields.salutation')"
                                        required
                                        prop="salutation_id"
                                    >
                                        <el-select
                                            v-model="formData.salutation_id"
                                            :placeholder="$trans('web_search.checkout_fields.salutation')"
                                            class="web-search-select"
                                            :disabled="!canSubmit"
                                        >
                                            <el-option :label="$trans('messages.salutations.male_salutation_key')" value="1" />
                                            <el-option :label="$trans('messages.salutations.female_salutation_key')" value="2" />
                                            <el-option :label="$trans('messages.salutations.male_dr_salutation_key')" value="3" />
                                            <el-option :label="$trans('messages.salutations.female_dr_salutation_key')" value="4" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>

                                <el-col :span="9">
                                    <el-form-item
                                        :label="$trans('web_search.checkout_fields.first_name')"
                                        required
                                        prop="first_name"
                                    >
                                        <el-input
                                            v-model="formData.first_name"
                                            :disabled="!canSubmit"
                                        />
                                    </el-form-item>
                                </el-col>

                                <el-col :span="9" style="padding-right: 0">
                                    <el-form-item
                                        :label="$trans('web_search.checkout_fields.last_name')"
                                        required
                                        prop="last_name"
                                    >
                                        <el-input
                                            v-model="formData.last_name"
                                            :disabled="!canSubmit"
                                        />
                                    </el-form-item>
                                </el-col>
                            </el-form-item>

                            <el-form-item
                                :label="$trans('web_search.checkout_fields.company_name')"
                                required
                                prop="company_name"
                            >
                                <el-input v-model="formData.company_name" :disabled="!canSubmit" />
                            </el-form-item>

                            <el-form-item
                                :label="$trans('web_search.checkout_fields.phone')"
                                required
                                prop="phone"
                            >
                                <el-input v-model="formData.phone" :disabled="!canSubmit" />
                            </el-form-item>

                            <el-form-item
                                :label="$trans('web_search.checkout_fields.email')"
                                required
                                prop="email"
                            >
                                <el-input v-model="formData.email" :disabled="!canSubmit" />
                            </el-form-item>

                            <el-form-item required prop="agree">
                                <el-checkbox v-model="formData.agree" :disabled="!canSubmit" id="agreeCb" />
                                <div style="margin-left: 10px; line-height: 18px">
                                    <div>
                                        <span>* {{ $trans('web_search.checkout_register_modal.consent') }}</span>
                                    </div>
                                    <div>
                                        <span v-html="$trans('web_search.checkout_register_modal.here_you_find_privacy_policy').replace(':privacy_policy_url', 'https://www.deutscheinterim.com/datenschutz')" />
                                    </div>
                                </div>
                            </el-form-item>

                            <el-form-item class="center" v-if="errorMessage">
                                <div class="error-wrapper">{{ errorMessage }}</div>
                            </el-form-item>

                            <el-form-item class="center">
                                <el-button
                                    type="primary"
                                    @click="onSubmit"
                                    :loading="isLoading"
                                    :disabled="!canSubmit || !isFormValid"
                                    id="send_vacancy"
                                >
                                    {{ $trans('web_search.profile_card.request_dossier') }}
                                </el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
            </template>

            <template #footer v-if="!successMessage">
                <AuthFooterModal />
            </template>
        </el-dialog>
    </div>
</template>

<script>
import CloseModalButton from "./CloseModalButton.vue";
import Tag from "./../Utils/Tag.vue";
import AuthFooterModal from "./../Auth/AuthFooterModal";
import axios from "axios";

export default {
    components: {
        CloseModalButton,
        Tag,
        AuthFooterModal,
    },
    props: {
        modelValue: { type: Boolean, default: false },
        profile: { type: Object, required: true },
    },
    emits: ["update:modelValue"],
    data() {
        const validateAgree = (rule, value, callback) => {
            if (value !== true) {
                callback(new Error("Sie müssen den Datenschutzbestimmungen zustimmen."));
            } else {
                callback();
            }
        };

        return {
            isLoading: false,
            successMessage: "",
            errorMessage: "",
            formData: {
                salutation_id: "",
                first_name: "",
                last_name: "",
                company_name: "",
                phone: "",
                email: "",
                agree: false,
            },
            rules: {
                salutation_id: [{ required: true, message: "Bitte wählen Sie eine Anrede.", trigger: "change" }],
                first_name: [{ required: true, message: "Bitte geben Sie Ihren Vornamen ein.", trigger: "blur" }],
                last_name: [{ required: true, message: "Bitte geben Sie Ihren Nachnamen ein.", trigger: "blur" }],
                company_name: [{ required: true, message: "Bitte geben Sie Ihren Firmennamen ein.", trigger: "blur" }],
                phone: [{ required: true, message: "Bitte geben Sie Ihre Telefonnummer ein.", trigger: "blur" }],
                email: [
                    { required: true, message: "Bitte geben Sie Ihre E-Mail-Adresse ein.", trigger: "blur" },
                    { type: "email", message: "Bitte geben Sie eine gültige E-Mail-Adresse ein.", trigger: ["blur", "change"] }
                ],
                agree: [{ validator: validateAgree, trigger: "change" }],
            },
        };
    },
    computed: {
        modelValueState: {
            get() { return this.modelValue; },
            set(value) { this.$emit("update:modelValue", value); }
        },
        isUserLoggedIn() { return !!window.user; },
        canSubmit() {
            return !this.isUserLoggedIn || (this.isUserLoggedIn && window.user.is_client === true);
        },
        isFormValid() {
            return (
                this.formData.salutation_id &&
                this.formData.first_name &&
                this.formData.last_name &&
                this.formData.company_name &&
                this.formData.phone &&
                this.formData.email &&
                this.formData.agree
            );
        }
    },
    methods: {
        getActiveSkills() { return this.profile.activeSkills.map(s => s.name).join(', '); },
        generateVacancyName() { return `${this.getActiveSkills()} ${this.$moment().format('DD.MM.YYYY HH:mm')}`; },
        prefillFormIfUserExists() {
            if (this.isUserLoggedIn) {
                this.formData.salutation_id = window.user.salutation_id ? String(window.user.salutation_id) : "";
                this.formData.first_name = window.user.first_name || "";
                this.formData.last_name = window.user.last_name || "";
                this.formData.company_name = window.user.company_name || "";
                this.formData.phone = window.user.phone || "";
                this.formData.email = window.user.email || "";
            }
        },
        async onSubmit() {
            if (!this.canSubmit || !this.isFormValid) return;
            const token = document.head.querySelector('meta[name="csrf-token"]')?.content;
            this.isLoading = true;
            try {
                const response = await axios.post("/api/web-search/request-candidate-dossier", {
                    ...this.formData,
                    profile_id: this.profile.id,
                    vacancy_name: this.generateVacancyName(),
                    selection_criterias: this.getActiveSkills(),
                }, { headers: { "X-CSRF-TOKEN": token } });
                this.successMessage = response.data.message;
                setTimeout(() => { this.modelValueState = false; }, 4000);
            } catch (error) {
                this.errorMessage = error.response?.data?.message || "Ein unerwarteter Fehler ist aufgetreten.";
            } finally {
                this.isLoading = false;
            }
        },
        resetForm() {
            this.$refs.formRef?.resetFields();
            this.successMessage = "";
            this.errorMessage = "";
            this.isLoading = false;
        },
    },
    watch: {
        modelValue: {
            handler(newVal) {
                if (newVal) {
                    this.prefillFormIfUserExists();
                    if (!this.canSubmit) {
                        this.errorMessage = this.$trans("web_search.checkout_response_messages.you_dont_have_access_please_contact_with_administrator").replace(":email", this.$config.company_email);
                    }
                } else {
                    this.errorMessage = "";
                }
            },
            immediate: true,
        },
    },
};
</script>

<style scoped>
.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 40px;
    background-color: #ededed;
    padding-top: 15px;
}

.your-selection-content {
    border: 1px solid #eee;
    padding: 15px;
    margin-bottom: 0px;
}

.your-selection-row {
    display: grid;
    grid-template-columns: 50px 1fr auto;
    gap: 15px;
    align-items: center;
}

.your-selection-row img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    object-fit: cover;
}

.match-rate {
    text-align: right;
}

.color-black {
    color: #303133;
    font-weight: bold;
}

.color-grey {
    color: #909399;
}

.success-wrapper {
    text-align: center;
    font-size: 1.2rem;
    color: #67c23a;
    padding: 20px;
}

.error-wrapper {
    color: #f56c6c;
}

.center {
    text-align: center;
}
.el-form-item.center .el-form-item__content {
    justify-content: center;
}

.request-dossier-modal :deep(.el-dialog) {
    --el-dialog-width: 750px;
    top: -100px !important;
}

.center {
    text-align: center;
}

.success-wrapper {
    color: #81bc8f;
    text-align: center;
    font-weight: bold;
    width: 100%;
}

.error-wrapper {
    color: #ff6b65;
    font-style: italic;
}

.request-dossier-modal :deep(.el-dialog .el-dialog__header) {
    padding-bottom: 0;
}

.request-dossier-modal :deep(.el-dialog .el-dialog__body) {
    padding-top: unset;
}

.request-dossier-modal :deep(.el-dialog .el-dialog__footer) {
    padding: 0;
}

.request-dossier-modal
    :deep(
        .el-form--default.el-form--label-top .el-form-item .el-form-item__label
    ) {
    margin-bottom: 0px;
}

.request-dossier-modal :deep(.center .el-form-item__content) {
    justify-content: center;
    margin-top: 57px;
}

.request-dossier-modal :deep(.el-form-item__content) {
    flex-wrap: unset;
}

.login-modal :deep(.el-form-item:last-child) {
    margin-bottom: 0;
}

.request-dossier-modal .el-row {
    background-color: #ededed;
    color: rgb(60, 60, 60);
    padding-bottom: 18px;
}

.request-dossier-modal .el-row:first-child {
    padding-top: 18px;
}

.request-dossier-modal .el-col {
    padding: 0 15px;
}

.request-dossier-modal .el-button {
    background-color: #41abc4;
    color: #fff;
    border-radius: 4px;
    height: 40px;
    width: 100%;
    max-width: 80%;
    font-size: 18px;
    font-weight: 300;
}

.request-dossier-modal .el-button:hover {
    background-color: #2699b2;
}

.request-dossier-modal .el-checkbox {
    --el-checkbox-font-size: 14px;
    --el-checkbox-font-weight: var(--el-font-weight-primary);
    --el-checkbox-text-color: #3c3c3c;
    --el-checkbox-input-height: 14px;
    --el-checkbox-input-width: 14px;
    --el-checkbox-border-radius: 0;
    --el-checkbox-bg-color: white;
    --el-checkbox-input-border: 1px solid #41abc4;
    --el-checkbox-disabled-border-color: var(--el-border-color);
    --el-checkbox-disabled-input-fill: var(--el-fill-color-light);
    --el-checkbox-disabled-icon-color: var(--el-text-color-placeholder);
    --el-checkbox-disabled-checked-input-fill: var(
        --el-border-color-extra-light
    );
    --el-checkbox-disabled-checked-input-border-color: var(--el-border-color);
    --el-checkbox-disabled-checked-icon-color: var(--el-text-color-placeholder);
    --el-checkbox-checked-text-color: #3c3c3c;
    --el-checkbox-checked-input-border-color: #41abc4;
    --el-checkbox-checked-bg-color: #41abc4;
    --el-checkbox-checked-icon-color: var(--el-color-white);
    --el-checkbox-input-border-color-hover: #41abc4;

    height: 24px;
}

.request-dossier-modal a,
.request-dossier-modal a:hover,
.request-dossier-modal a:visited {
    color: rgb(60, 60, 60);
}

.request-dossier-modal .el-button :deep(span) {
    pointer-events: none !important;
}

@media only screen and (max-width: 800px) {
    .request-dossier-modal :deep(.el-dialog) {
        --el-dialog-width: 95%;
        margin-top: 50px;
    }

    .request-dossier-modal :deep(.flex-wrap-on-mobile .el-form-item__content) {
        flex-wrap: wrap;
    }

    .request-dossier-modal .el-col-6,
    .request-dossier-modal .el-col-9 {
        max-width: 100%;
        flex: 0 0 100%;
        padding: 0;
    }

    .request-dossier-modal .el-col-6:not(:last-child),
    .request-dossier-modal .el-col-9:not(:last-child) {
        margin-bottom: 18px;
    }

    .request-dossier-modal .el-button {
        white-space: unset;
        height: unset;
    }
}

.request-dossier-modal :deep(.el-dialog) {
    --el-dialog-width: 800px;
    top: -100px !important;
}

.center {
    text-align: center;
}

.success-wrapper {
    color: #81bc8f;
    text-align: center;
    font-weight: bold;
    width: 100%;
    font-size: 16px;
}

.error-wrapper {
    color: #ff6b65;
    font-style: italic;
}

.request-dossier-modal :deep(.el-dialog .el-dialog__header) {
    padding-bottom: 0;
    margin-right: unset !important;
}

.request-dossier-modal
    :deep(
        .el-form--default.el-form--label-top .el-form-item .el-form-item__label
    ) {
    margin-bottom: 0px;
}

.request-dossier-modal .el-row {
    background-color: #ededed;
    color: rgb(60, 60, 60);
    padding-bottom: 18px;
}

.request-dossier-modal .el-row:first-child {
    padding-top: 18px;
}

.request-dossier-modal .el-row:nth-child(3) {
    margin-top: 20px;
    padding-top: 18px;
}

.request-dossier-modal .el-col {
    padding: 0 15px;
}

.request-dossier-modal .title-col {
    text-align: left;
    font: normal normal 500 24px/29px Barlow;
    letter-spacing: -0.24px;
    color: #3c3c3c;
    padding-top: 4px;
    padding-bottom: 4px;
    border-bottom: 1px solid rgb(60, 60, 60);
    margin-left: 14px;
    width: 96%;
}

.request-dossier-modal-content > div:nth-child(1) {
    max-width: 60%;
    flex: 0 0 60%;
}

.request-dossier-modal-content > div:nth-child(2) {
    max-width: 40%;
    flex: 0 0 40%;
}

.request-dossier-modal .el-button {
    border-radius: 4px;
    height: 40px;
    width: 100%;
    max-width: 730px;
    font-size: 18px;
    font-weight: 300;
    border-color: #41abc4;
}

.request-dossier-modal .el-button.is-disabled {
    background-color: #bababa !important;
    border-color: #bababa !important;
}

.request-dossier-modal .el-button.is-disabled:hover {
    background-color: #bababa !important;
    border-color: #bababa !important;
}

.request-dossier-modal .el-button:not(.el-button--info) {
    background-color: #41abc4;
    color: #fff;
}

.request-dossier-modal .el-button:not(.el-button--info):hover {
    background-color: #2699b2;
}

.your-selection-content {
    display: block;
    max-height: 300px;
    overflow-y: auto;
}

.your-selection-row {
    display: flex;
    padding: 8px 16px;
}

.your-selection-row:not(:last-child) {
    padding-bottom: 4px;
    border-bottom: 1px solid rgb(60, 60, 60);
}

.your-selection-row > div:nth-child(1) > img {
    width: 80px;
    height: 80px;
    border-radius: 50%;
}

.your-selection-row > div:nth-child(2) {
    flex-grow: 1;
    padding: 5px 15px;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    overflow-y: hidden;
}

.your-selection-row > div:nth-child(4) {
    display: flex;
    align-items: center;
}

.your-selection-row > div:nth-child(4):first-child {
    margin-top: -55px;
}

.your-selection-row > div:nth-child(4) > .el-icon {
    background-color: #41abc4;
    padding: 10px;
    width: 22px;
    height: 22px;
    border-radius: 10px;
    background-image: linear-gradient(#ff6b65 0 0);
    background-size: 100% 0em;
    background-repeat: no-repeat;
    transition: 0.1s;
}

.your-selection-row > div:nth-child(4) > .el-icon:hover {
    transition: 0.1s;
    background-size: 100% 100%;
    cursor: pointer;
}

.your-selection-row > div:nth-child(4) > .el-icon > svg {
    width: 22px;
    height: 22px;
}

.match-rate {
    font-size: 20px;
    min-width: 120px;
}

.tag-header {
    margin-left: 124px;
    font-weight: bold;
    font-size: 18px;
}

.match-rate-header {
    margin-left: 600px;
    bottom: 25px;
    position: relative;
    font-weight: bold;
    font-size: 18px;
}

@media only screen and (max-width: 500px) {
    .your-selection-content {
        max-height: unset;
    }

    .your-selection-row {
        justify-content: space-between;
        flex-wrap: wrap;
    }

    .your-selection-row > div:nth-child(2) {
        order: 3;
        padding: 10px 0;
        width: 100%;
    }
}

@media only screen and (max-width: 850px) {
    .el-dialog {
        position: fixed;
        z-index: 100;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        border-radius: 8px;
        width: calc(100% - 30px);
        margin: 15px;
        box-sizing: border-box;
        overflow-y: scroll;
    }

    .request-dossier-modal :deep(.el-dialog) {
        --el-dialog-width: 95%;
    }

    .request-dossier-modal-content > div:nth-child(1) {
        max-width: 100%;
        flex: 0 0 100%;
    }

    .request-dossier-modal-content > div:nth-child(2) {
        display: none;
    }
}

@media only screen and (max-width: 790px) {
    .match-rate-header {
        margin-left: unset;
        bottom: 27px;
    }

    .tag-header .color-grey {
        margin-left: -108px;
    }

    .match-rate-header .color-grey {
        margin-left: 44%;
    }

    .match-rate {
        min-width: 75px;
    }
}
</style>